import autoFocus from "./auto-focus.js";
import ariaFromAttr from "./aria-from-attr.js";
import btnRipple from "./btn-ripple.js";
import compareTo from "./compare-to.js";
import confirmClear from "./confirm-clear.js";
import dateTimeInput from "./date-time-input";
import moneyInput from "./money-input";
import htmlViewer from "./html-viewer.js";
import inputRipple from "./input-ripple.js";
import mask from "./ui-mask.js";
import onTrigger from "./on-trigger.js";
import selectBox from "./select-box.js";
import selectOnFocus from "./select-on-focus.js";
import submit from "./programmatic-submit.js";
import tabListNavigation from "./tab-list-navigation";
import trapFocus from "./trap-focus.js";
import veslNoUnicode from "./vesl-no-unicode";
import windowResize from "./window-resize";
import uibModalWindow from "./uib-modal-window.js";
import uibTooltip from "./uib-tooltip.js";
import onEscape from "./on-escape.js";
import preventScroll from "./prevent-scroll.js";
import restoreFocusWhen from "./restore-focus-when";
import { authorizeAttribute } from "./authorize/authorize-attribute.js";
import { authorizeComponent } from "./authorize/authorize-component.js";
import i18n from "./i18n";
import fileUploadInput from "./file-upload-input.js";
import fileUploadDropzone from "./file-upload-dropzone.js";

const deps = [
	autoFocus,
	ariaFromAttr,
	btnRipple,
	compareTo,
	confirmClear,
	dateTimeInput,
	moneyInput,
	inputRipple,
	mask,
	onTrigger,
	onEscape,
	htmlViewer,
	uibModalWindow,
	uibTooltip,
	selectBox,
	selectOnFocus,
	submit,
	tabListNavigation,
	trapFocus,
	preventScroll,
	restoreFocusWhen,
	veslNoUnicode,
	windowResize,
	authorizeAttribute,
	authorizeComponent,
	i18n,
	fileUploadInput,
	fileUploadDropzone
];

export default angular.module("vesl.behaviors", deps).name;
